var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcUsuariosInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "ic-perfil-inactive",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:none}.cls-2{fill:#8b8b8b}\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_881",
    d: "M0 0h23v23H0z",
    className: "cls-1",
    "data-name": "Rect\\xE1ngulo 881"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1857",
    d: "M18.9 4.1a10.465 10.465 0 1 0 0 14.8 10.442 10.442 0 0 0 0-14.8zm1.3 7.4a8.728 8.728 0 0 1-8.8 8.7 8.75 8.75 0 1 1 0-17.5 8.878 8.878 0 0 1 8.8 8.8z",
    className: "cls-2",
    "data-name": "Trazado 1857"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "ic_perm_identity_24px",
    d: "M11.5 6.6a1.9 1.9 0 1 1-1.9 1.9 1.9 1.9 0 0 1 1.9-1.9m0 8.3c2.7 0 5.6 1.3 5.6 1.9V18s-2.8 3-5.6 3-5.6-3-5.6-3v-1.2c0-.6 2.9-1.9 5.6-1.9m0-10a3.691 3.691 0 0 0-3.7 3.7 3.63 3.63 0 0 0 3.7 3.7 3.63 3.63 0 0 0 3.7-3.7 3.691 3.691 0 0 0-3.7-3.7zm0 8.2c-2.5 0-7.4 1.2-7.4 3.7v.6s3.7 3.5 7.4 3.5 7.4-3.5 7.4-3.5v-.6c0-2.4-4.9-3.7-7.4-3.7z",
    className: "cls-2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUsuariosInactive);
export default __webpack_public_path__ + "static/media/ic-usuarios-inactive.898c6fb76f35d4f24572a641e5b41202.svg";
export { ForwardRef as ReactComponent };